import {IYearPickerDates} from "../Components/YearPicker";

/**
 * Converts a start and end date to an IYearPickerDates object.
 * @param start - Start date as UTC timestamp.
 * @param end - End date as UTC timestamp.
 */
export const yearPickerDates = (start: string | undefined | null, end: string | undefined | null): IYearPickerDates => {
    return {start: start ? start : undefined, end: end ? end : undefined}
}